import axios from "axios";
import useQuery from "../../utils/useQuery";

const axiosClient = axios.create();

axiosClient.defaults.baseURL = process.env.REACT_APP_URL_API;

const urlParams = useQuery();
const token = urlParams.get("token") || "";

axiosClient.defaults.headers.common.Authorization = token;

export default axiosClient;
